import type { ListPageConfig } from '../types'
import { formatStatusLabel } from '@/lib/status_colors'
import { STATIC_CATALOGUE } from '@/components/engagements/use-supported-definitions'

const STATUS_OPTIONS = [
  'ACTIVE', 'INTAKE_PENDING', 'DOCUMENTS_PENDING', 'IN_PROGRESS',
  'BLOCKED', 'COMPLETED', 'CANCELLED', 'FAILED',
].map((s) => ({ value: s, label: formatStatusLabel(s)! }))

// Derived from the SAME catalogue the create wizard uses (use-supported-definitions.ts)
// so this filter can't silently drift out of sync with what's actually creatable —
// that drift is exactly what made UAE engagements invisible here (ENT-335): this file
// kept its own India-only list even after the wizard's catalogue gained AE.
const COUNTRY_OPTIONS = STATIC_CATALOGUE.countries.map((c) => ({ value: c.code, label: c.label }))
const ENTITY_TYPE_OPTIONS = Object.values(STATIC_CATALOGUE.entityTypesByCountry).flat()

export const engagementsFilterConfig: ListPageConfig = {
  routeId: '/engagements/',
  pageId: 'engagements',
  pagination: { pageSize: 20 },
  fields: [
    // `placeholder` IS this field's accessible name — FilterBar routes `type: 'search'` fields
    // out of the rail into its own toolbar DebouncedSearchField, which reads only
    // `value`/`onChange`/`placeholder` (never `ariaLabel`).
    { id: 'search', label: 'Search', type: 'search', placeholder: 'Search by company name…' },
    {
      id: 'status',
      label: 'Status',
      type: 'select',
      allLabel: 'All statuses',
      options: STATUS_OPTIONS,
    },
    {
      id: 'country',
      label: 'Country',
      type: 'select',
      allLabel: 'All countries',
      options: COUNTRY_OPTIONS,
      responsiveHide: true,
    },
    {
      id: 'entityType',
      label: 'Entity type',
      type: 'select',
      allLabel: 'All entity types',
      options: ENTITY_TYPE_OPTIONS,
      responsiveHide: true,
    },
  ],
}
